import { ThemeProvider as ThemeProviderMui } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { useAppSelector } from "../../../../business.InterfaceLayer/store/services/hooks.service/redux.hook";
import { themeSlice } from "../../../../business.InterfaceLayer/store/entities/theme.entity/redux/slice";
import { THEME_FIELDS } from "../../../../business.InterfaceLayer/store/entities/theme.entity/redux/fields";

const ThemeProvider = ({
	children,
	darkStyles,
	lightStyles,
}: {
	children: JSX.Element;
	darkStyles: Theme;
	lightStyles: Theme;
}) => {
	const theme = useAppSelector((state) => state[themeSlice.name]);
	// const dispatch = useAppDispatch();
	return theme?.[THEME_FIELDS.STATE] ? (
		<ThemeProviderMui
			theme={
				theme?.[THEME_FIELDS.STATE] === THEME_FIELDS.LIGHT
					? lightStyles
					: darkStyles
			}
		>
			{children}
			{/*<div>*/}
			{/*<div*/}
			{/*	onClick={() => {*/}
			{/*		dispatch(*/}
			{/*			themeActions.changeTheme({*/}
			{/*				[THEME_FIELDS.STATE]:*/}
			{/*					theme?.[THEME_FIELDS.STATE] === THEME_FIELDS.LIGHT*/}
			{/*						? THEME_FIELDS.DARK*/}
			{/*						: THEME_FIELDS.LIGHT,*/}
			{/*			})*/}
			{/*		);*/}
			{/*	}}*/}
			{/*>*/}
			{/*	Меняю тему*/}
			{/*</div>*/}
			{/*</div>*/}
		</ThemeProviderMui>
	) : null;
};

export default ThemeProvider;
